/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function JobRankFromJSON(json) {
    return JobRankFromJSONTyped(json, false);
}
export function JobRankFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'workerId': !exists(json, 'workerId') ? undefined : json['workerId'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'trade': !exists(json, 'trade') ? undefined : json['trade'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'createIndex': !exists(json, 'createIndex') ? undefined : json['createIndex'],
        'autoAssignWorkerFlag': !exists(json, 'autoAssignWorkerFlag') ? undefined : json['autoAssignWorkerFlag'],
    };
}
export function JobRankToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'workerId': value.workerId,
        'jobType': value.jobType,
        'trade': value.trade,
        'rank': value.rank,
        'createIndex': value.createIndex,
        'autoAssignWorkerFlag': value.autoAssignWorkerFlag,
    };
}
